import { connect } from 'react-redux'
import { forwardRef, useState } from 'react'
import { Button } from 'antd'
import Feather from '@sysunite/react-feather'
import { NodePicker, withBounds } from 'Components'
import { setGraphShowingNode } from 'Actions/graph'
import { loadGraphData } from 'Services/GraphUtils'
import { updateGraphNodes } from 'Actions/graph'

GraphShowingNodePopover = forwardRef(({
  graphData,
  isShowingNode,
  setGraphShowingNode,
  updateGraphNodes,
  style
}, ref) ->

  [nodes, setNodes] = useState(undefined)

  getId = (uid) -> uid.split('@')[0]

  addToGraph = ->
    updateGraphNodes(
      await loadGraphData(
        new Weaver.Query().restrict(
          nodes.map(getId)
        ).selectOut('*')
        .selectIn('*')
      )
    )

  <div
    ref={ref}
    style={{
      boxShadow: 'rgba(0,0,0,0.06) 0px 4px 12px 0px',
      borderRadius: '9px',
      padding: '16px',
      zIndex: 2,
      position: 'fixed',
      width: 400
      style...
    }}
  >
    <Button
      type="link"
      onClick={ -> setGraphShowingNode(undefined) }
      style={{ padding: 0, paddingRight: 16 }}
    ><Feather type="x" /></Button>
    <NodePicker
      style={{ width: '75%', paddingRight: 8 }}
      mode="multiple"
      onSelect={(vals) -> setNodes(vals)}
    />
    <Button
      disabled={!nodes}
      type="primary"
      onClick={ ->
        addToGraph()
        setNodes(undefined)
        setGraphShowingNode(undefined)
      }
    >Ok</Button>
  </div>
)

mapStateToProps = ({ graph: { isShowingNode, graphData } }) -> { isShowingNode, graphData }

export default connect(mapStateToProps, { setGraphShowingNode, updateGraphNodes })(
  withBounds(GraphShowingNodePopover)
)
